import { Link } from 'react-router-dom'
import { addProjectsAndUploadData } from '../../../../../Data/Application/Users/UsersProfile/UsersProfile'
import { Href } from '../../../../../Utils/Constants'
import { Btn } from '../../../../../AbstractElements'

const AddProjectsAndUploadTableBody = () => {
  return (
    <tbody>
      {addProjectsAndUploadData.map((data, index) => (
        <tr key={index}>
          <td>
            <Link className="text-inherit" to={Href}>
              {'Untrammelled Prevents'}
            </Link>
          </td>
          <td>{data.date}</td>
          <td>
            <span className={`status-icon ${data.statusClass}`} /> {data.status}
          </td>
          <td>{data.price}</td>
          <td className="text-end">
            <Btn size='sm' color='primary' href={Href}>
              <i className="fa fa-pencil" />
            </Btn>
            <Btn size='sm' color='info' href={Href}>
              <i className="fa fa-link" />
            </Btn>
            <Btn size='sm' color='danger' href={Href}>
              <i className="fa fa-trash" />
            </Btn>
          </td>
        </tr>
      ))}
    </tbody>
  )
}

export default AddProjectsAndUploadTableBody